import SedeEntity from "../../../../../domain/entities/SedeEntity";
import HostApi from "../../../../settings/HostApi";

const GetAllSedesApiImpl = async (): Promise<SedeEntity[]> => {
    const relativeUrl = "/sedes/";
    try {
        const response = await HostApi.get(relativeUrl);
        return response.map((sede: any): SedeEntity => ({
            id: sede.id,
            name: sede.name,
            address: sede.address,
            phone: sede.phone,
            photo: sede.photo,
            description: sede.description,
            latitude: sede.latitude,
            longitude: sede.longitude,
            active: sede.active,
        }));
    } catch (error) {
        return [];
    }
};

export default GetAllSedesApiImpl;
